import { createIdGenerator } from "ai";

/**
 * Namespace pattern for client-minted chat user-message ids: `uimsg_` + a URL-safe
 * random part. A later PR1 slice enforces this at the request boundary / repository
 * once every send path is confirmed to mint ids through `createChatUserMessageId`.
 */
export const CHAT_USER_MESSAGE_ID_PATTERN = /^uimsg_[A-Za-z0-9_-]{16,96}$/;

/**
 * Mints a stable, client-assigned id for a NEW user chat message in the `uimsg_`
 * namespace (brief 011 Piece 1). Wired into `useChat({ generateId })` in
 * `useMcpChat`, so every `ChatProvider`/`useMcpChat` consumer's user messages carry
 * this shape. The server persists the client id verbatim as `externalMessageId`,
 * which lets the client reconcile a turn's streamed and persisted copies by a shared
 * id. Produces `uimsg_<24 url-safe chars>`, satisfying `CHAT_USER_MESSAGE_ID_PATTERN`
 * (24 ∈ [16, 96]). Assistant turns are unaffected — their ids come from the server
 * stream, not this client generator.
 */
export const createChatUserMessageId = createIdGenerator({ prefix: "uimsg", separator: "_", size: 24 });
